import {
	GetValuemappingProfilesParams,
	GetValuemappingProfilesRequest,
} from '@Types/valuemappingManager.types';
import {
	buildSearchQueryParam,
	parseSearchFiltersWithOptions,
} from '@Utils/buildSearchQueryParam';

type ValueMappingProfilesPaginationHookReturn = {
	createSearchParams(
		req: GetValuemappingProfilesRequest,
	): GetValuemappingProfilesParams;
};

export const useValueMappingProfilesPagination =
	(): ValueMappingProfilesPaginationHookReturn => {
		const createSearchParams: ValueMappingProfilesPaginationHookReturn['createSearchParams'] =
			(req: GetValuemappingProfilesRequest) => {
				const paramsValues: GetValuemappingProfilesParams = {
					limit: req.pageSize,
					offset: ((req.page || 1) - 1) * req.pageSize,
					sortBy: `${req.sort.field}:${req.sort.sortOrder}`,
				};

				if (req.search) {
					paramsValues.q = `name:${req.search},sensors:${req.search}`;
				}

				if (req.filters && Object.keys(req.filters).length) {
					const qFilters = buildSearchQueryParam(
						parseSearchFiltersWithOptions(req.filters),
					);

					if (qFilters) {
						paramsValues.q = paramsValues.q
							? `${paramsValues.q},${qFilters}`
							: qFilters;
					}
				}

				return paramsValues;
			};

		return { createSearchParams: createSearchParams };
	};

export default useValueMappingProfilesPagination;
